<template>
    <div class="cc-shaim-baliknapostu" @click.prevent.stop>
        <div class="cc-shaim-baliknapostu__header">
            <div class="cc-shaim-baliknapostu__title mb-2" v-if="shaimBalikNaPostu.selected.id">{{ shaimBalikNaPostu.selected.name }}</div>
            <button class="cc-button cc-button--delivery-branch btn btn-primary" @click.stop="openWidget">{{ deliveryBranchButtonName }}</button>
        </div>
        <div class="cc-shaim-baliknapostu__main" v-if="isWidgetVisible">
            <div class="cc-popup cc-popup--with-overlay" v-bind:class="{'cc-show': isWidgetVisible}" @mousedown.self.prevent.stop="closeWidget">
                <div class="cc-popup__content">
                    <div class="cc-popup__header">
                        <div class="cc-popup__title">{{ translations['Search for parcel shop'] }}</div>
                    </div>
                    <div class="cc-popup__main">
                        <div class="cc-form-input">
                            <label for="shaimBalikNaPostu.search" class="cc-label cc-label--text">{{ translations['Postal code or city'] }}</label>
                            <input id="shaimBalikNaPostu.search" type="email" name="shaimBalikNaPostu.search" class="cc-input cc-input--text" @keyup.enter="search" v-model="searchQuery">
                        </div>
                        <table class="cc-table" v-if="shaimBalikNaPostu.result.length > 0">
                            <thead class="cc-table__thead">
                                <tr class="cc-table__tr">
                                    <th class="cc-table__th">
                                        {{ translations['Parcel shop'] }}
                                    </th>
                                    <th class="cc-table__th">
                                        {{ translations['Street'] }}
                                    </th>
                                    <th class="cc-table__th">
                                        {{ translations['Controls'] }}
                                    </th>
                                </tr>
                            </thead>
                            <tbody class="cc-table__tbody">
                                <tr v-for="postOffice in shaimBalikNaPostu.result" v-bind:key="postOffice.id" class="cc-table__tr">
                                    <td class="cc-table__td">
                                        {{ postOffice.naz_prov }}
                                    </td>
                                    <td class="cc-table__td">
                                        {{ postOffice.adresa }}
                                    </td>
                                    <td class="cc-table__td">
                                        <button class="cc-button cc-button--select-post-office btn btn-primary btn-sm" :data-post-office-id="postOffice.id" :data-psc="postOffice.psc" :data-post-office-name="postOffice.adresa" @click.prevent.stop="selectBranch">{{ translations['Select branch'] }}</button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="cc-popup__footer">
                        <button class="cc-button cc-button--popup-cancel btn btn-secondary" @click.prevent.stop="closeWidget">{{ translations['Cancel'] }}</button>
                        <button class="cc-button cc-button--popup-ok btn btn-success" @click.prevent.stop="search">{{ translations['Search'] }}</button>
                    </div>
                </div>
            </div>
        </div>
        <div class="cc-shaim-baliknapostu__main--big" v-if="isBigWidgetVisible">
          <div class="cc-popup cc-popup--with-overlay" v-bind:class="{'cc-show': isBigWidgetVisible}" @mousedown.self.prevent.stop="closeWidget">
            <div class="cc-popup__content">
              <div class="cc-popup__main">
                <iframe id="find_baliknapostu_zip_city" class="mapa_iframe" :title="translations['Select parcel shop']" src="https://b2c.cpost.cz/locations/?type=POST_OFFICE&phone=false&skipLocation=false" allow="geolocation" width="100%" height="800px"></iframe>
              </div>
            </div>
          </div>
        </div>
    </div>
</template>

<script>
import {mapState} from 'vuex';

export default {
  computed: {
    ...mapState({
      translations: state => state.translations,
      shaimBalikNaPostu: state => state.shaimBalikNaPostu,
    }),
    deliveryBranchButtonName: function () {
      return this.shaimBalikNaPostu.selected.id ? this.translations['Change'] : this.translations['Select branch'];
    },
    isWidgetVisible: function () {
      if (this.carrier.extra.widget === true) {
        return false;
      }
      if (this.selectedCarrier === null) {
        return this.shouldWidgetBeShown;
      }
      if (this.selectedCarrier.module === 'shaim_baliknapostu' && this.shaimBalikNaPostu.selected.id === null) {
        return true;
      }

      return this.shouldWidgetBeShown;
    },
    isBigWidgetVisible: function () {
      if (this.carrier.extra.widget === false) {
        return false;
      }
      if (this.selectedCarrier === null) {
        return this.shouldWidgetBeShown;
      }
      if (this.selectedCarrier.module === 'shaim_baliknapostu' && this.shaimBalikNaPostu.selected.id === null) {
        return true;
      }

      return this.shouldWidgetBeShown;
    }
  },
  data: function () {
    return {
      shouldWidgetBeShown: false,
      searchQuery: '',
    };
  },
  methods: {
    openWidget: function () {
      this.$store.commit('SET_SHAIM_BALIKNAPOSTU_SEARCH', '');
      this.$store.commit('SET_SHAIM_BALIKNAPOSTU_POST_OFFICES', {});
      this.shouldWidgetBeShown = true;
    },
    closeWidget: function () {
      if (this.shaimBalikNaPostu.selected.id === null) {
        this.$emit('closeWithoutParcelShop');
      }
      this.shouldWidgetBeShown = false;
    },
    search: function () {
      this.$store.commit('SET_SHAIM_BALIKNAPOSTU_SEARCH', this.searchQuery);
      this.$store.dispatch('LOAD_SHAIM_BALIKNAPOSTU');
    },
    selectBranch: function (event) {
      this.$store.commit('SET_SHAIM_BALIKNAPOSTU_SELECTED_POST_OFFICE', {id: event.currentTarget.dataset.postOfficeId, psc: event.currentTarget.dataset.psc, name: event.currentTarget.dataset.postOfficeName});
      this.closeWidget();
      this.$store.commit('SET_SHAIM_BALIKNAPOSTU_SEARCH', '');
      this.$store.commit('SET_SHAIM_BALIKNAPOSTU_POST_OFFICES', {});
      this.$emit('selectCarrier', this.carrier)
    },
    iframeListener: function (event) {
      if (event.origin.match(/b2c\.cpost\.cz/) && event.data.message === "pickerResult" && event.data.point.type == 'POST_OFFICE') {
        if (event.data.point.zip) {
          var id = event.data.point.id;
          var psc = event.data.point.zip;
          var full = event.data.point.name + ', ' + event.data.point.address;

          if (psc) {
            this.$store.commit('SET_SHAIM_BALIKNAPOSTU_SELECTED_POST_OFFICE', {
              id: id,
              psc: psc,
              name: full
            });
            this.closeWidget();
            this.$emit('selectCarrier', this.carrier)
          }
        }
      }
    }
  },
        mounted() {
            if (this.carrier.extra.widget) {
              window.addEventListener("message", this.iframeListener);
            }
        },
  props: [
    'carrier',
    'selectedCarrier',
  ],
};
</script>

<style lang="scss" scoped="scoped">
  @import "../../../_common/scss/popups";
  @import "../../../_common/scss/tables";
  #app {
    .cc-table {
      margin-top: 1rem;
    }
  }
  #app .cc-table__td {
    padding: 0.5rem 1rem;
  }
  .cc-input.cc-input--text {
    padding: 1rem;
  }
  .cc-shaim-baliknapostu .cc-table__tr {
    border-top: 1px solid #eeeeee;
  }
  .cc-button {
    white-space: nowrap;
  }

  /* big widget */
  #app .cc-shaim-baliknapostu__main--big .cc-popup__content {
    top: auto;
    left: auto;
    -webkit-transform: none;
    transform: none;
    min-width: calc(100% - 2rem);
    max-width: 100%;
    padding: 0;
  }

  #app .cc-popup__main {
    padding: 0;
  }

</style>
